var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49839 1.06899H12.5358V2.80463H0.386292V1.06899H3.42366L4.29148 0.201172H8.63057L9.49839 1.06899ZM2.99 15.8217C2.0354 15.8217 1.25437 15.0406 1.25437 14.086V3.67222H11.6682V14.086C11.6682 15.0406 10.8872 15.8217 9.93255 15.8217H2.99Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.27905,
    y: 5.40723,
    width: 1.2728,
    height: 6.94255,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.82428,
    y: 5.40723,
    width: 1.2728,
    height: 6.94255,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.36981,
    y: 5.40723,
    width: 1.2728,
    height: 6.94255,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAreaIcon);
export default __webpack_public_path__ + "static/media/deleteAreaIcon.ccdfc66893979777312329ed3f1394f8.svg";
export { ForwardRef as ReactComponent };